module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chart-trending-turns"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-5daf4e9c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/dataVisualization/d3js/trendingTurns.vue
// module id = 1702
// module chunks = 61